import { AxiosError } from "axios";
import { useCallback, useState } from "react";
import { Nullable, TriggeredHook } from "sonobello.utilities.react";

import { OpsCalendar } from "../../../../Models/OpsCalendar";
import { Error } from "../../../../Utils/Errors";
import OpsEndpointPathsUtility from "../../../../Utils/OpsEndpointPathsUtility";
import { useApi } from "../../../../Utils/useApi";
import { IUseGetCenterCalendarProps, IUseGetCenterCalendarTrigger } from "../Types/useGetCenterCalendarProps";

/** A hook which obtains the calendar for the requested center and has masked availability for the specified customer. */
const useGetCalendar: TriggeredHook<
  OpsCalendar,
  IUseGetCenterCalendarTrigger,
  AxiosError,
  IUseGetCenterCalendarProps
> = ({ contactId }) => {
  const [requestProps, setRequestProps] = useState<Nullable<IUseGetCenterCalendarTrigger>>(null);

  const {
    response: calendarResponse,
    error: calendarError,
    isLoading
  } = useApi<OpsCalendar>({
    url: requestProps
      ? OpsEndpointPathsUtility.getCalendarUrl(contactId, requestProps.customerId, requestProps.customerCenterId)
      : undefined,
    method: "get",
    valid: Boolean(requestProps),
    error: Error.GetCenterCalendar
  });

  const execute = useCallback((props: IUseGetCenterCalendarTrigger) => setRequestProps(props), []);

  return {
    result: calendarResponse ?? null,
    error: calendarError ?? null,
    execute,
    isLoading
  };
};

export default useGetCalendar;
